import { AutomationApplication, AutomationPage, AutomationUiObject, CommandDfinition, OperationParameters, ReusableComponent, ReusableScript, ScriptGroup, Service, ServiceOperation, TestScript } from "../../models/automation-fields";

export interface AutomationState {
  commandDefinitions: CommandDfinition[];
  scriptGroup: ScriptGroup[];
  testScript: TestScript[];
  reusableComponent: ReusableComponent[];
  reusableScript: ReusableScript[];
  applications: { [id: string]: AutomationApplication[] };
  pages: { [id: string]: AutomationPage[] };
  uiObjects: { [id: string]: AutomationUiObject[] };
  apiServices: Service[],
  serviceOperations: ServiceOperation[],
  operationParameters: OperationParameters[],
  operationHeaders: OperationParameters[],
  error: any;
  loading: boolean,
}

export const initialAutomationState: AutomationState = {
  commandDefinitions: [],
  scriptGroup: [],
  testScript: [],
  reusableComponent: [],
  reusableScript: [],
  applications: {},
  pages: {},
  uiObjects: {},
  apiServices:[],
  serviceOperations:[],
  operationParameters:[],
  operationHeaders:[],
  error: null,
  loading: false,
};

export { AutomationUiObject };

